import { jsxs as b, jsx as i } from "react/jsx-runtime";
import { useField as p } from "formik";
import { isString as I } from "lodash-es";
import x, { useState as T, useEffect as g, useCallback as A } from "react";
import E from "../../hooks/useDebounceWithOnBlur.js";
import { I as v } from "../../constants-C9JADvZj.mjs";
import { Wrapper as w, Label as B, TextArea as N, ErrorLabel as O, HintLabel as F } from "./styled.js";
const L = x.forwardRef(
  function({
    ariaLabel: u = "",
    hint: s,
    label: e,
    mode: r = "Normal",
    maxLength: c = 100,
    maxRows: n = 3,
    name: a,
    error: l,
    errorLabelProps: m,
    ...o
  }, f) {
    return /* @__PURE__ */ b(w, { children: [
      /* @__PURE__ */ i(B, { htmlFor: a, id: `${a}.label`, children: e }),
      /* @__PURE__ */ i(
        N,
        {
          ref: f,
          name: a,
          mode: r,
          minRows: r === "Input" ? 1 : 6,
          maxRows: r === "Input" ? n : Number.POSITIVE_INFINITY,
          "aria-label": u || e,
          "aria-invalid": !!l,
          "aria-labelledby": e ? `${a}.label` : o["aria-labelledby"],
          maxLength: c,
          $error: l ? "true" : "false",
          ...o
        }
      ),
      l && /* @__PURE__ */ i(O, { ...m, children: l }),
      s && /* @__PURE__ */ i(F, { children: s })
    ] });
  }
), k = ({
  delay: d = v,
  name: u,
  ...s
}) => {
  const [e, r] = p(u), [c, n] = T(""), [a, l] = E({
    delay: d,
    field: e,
    // trim the whitespace from the ends of the text area input
    doOnBlur: (t) => {
      I(t.target.value) && (t.target.value = t.target.value.trim());
    }
  }), m = r.touched && !!r.error, { value: o } = e;
  g(() => {
    n(o || "");
  }, [o]);
  const f = A(
    (t) => {
      t.persist();
      const h = t.currentTarget.value;
      n(h), a.current = t;
    },
    [a]
  );
  return /* @__PURE__ */ i(
    L,
    {
      ...s,
      name: e.name,
      onChange: f,
      onBlur: l,
      error: m ? r.error : void 0,
      value: c
    }
  );
};
export {
  L as TextArea,
  k as default
};
